var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3327 0H2.99935C1.71602 0 0.677683 1.05 0.677683 2.33333L0.666016 21C0.666016 22.2833 1.70435 23.3333 2.98768 23.3333H16.9993C18.2827 23.3333 19.3327 22.2833 19.3327 21V7L12.3327 0ZM2.99935 21V2.33333H11.166V8.16667H16.9993V21H2.99935Z",
    fill: "#2F736E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.237dee452e4cbbab8e01a71fa2b62d2c.svg";
export { ForwardRef as ReactComponent };